// extracted by mini-css-extract-plugin
export default {"recommendationCardContainer":"RecommendationCard_recommendationCardContainer__acP+m","tabsWithStatusWrapper":"RecommendationCard_tabsWithStatusWrapper__cBvqX"};